import { useReportListQuery } from '__codegen__/api'

export const useReportList = () => {
  const { data, loading, error } = useReportListQuery()

  return {
    reports: (data && data.reports) || [],
    loading,
    error,
  }
}
